import { INDUSTRY_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: INDUSTRY_MNG,
  params: null,
  view: {
    title: '创建行业',
    labelPosition: 'right',
    content: [
      {
        $id: 'industryName',
        $type: 'input',
        label: '行业名',
        rules: [
          {
            notEmpty: '行业名'
          }
        ]
      },
      {
        $id: 'industryCode',
        $type: 'input',
        label: '行业编码',
        rules: [
          {
            notEmpty: '行业编码'
          }
        ]
      },
      {
        $id: 'remarks',
        $type: 'input',
        $el: {
          type: 'textarea',
          rows: 5
        },
        label: '备注'
      },
      {
        $id: 'sceneDesc',
        $type: 'input',
        label: '行业场景说明',
        $el: {
          type: 'textarea',
          rows: 5
        }
      }
    ]
  }
}
